module.exports = __webpack_public_path__ + "img/bottomSon.230958cb.svg";